/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { Moment } from "moment";
import moment from "moment";
import type { FC } from "react";
import DateFormatter from "~/utils/DateFormatter";
import styles from "./style.module.less";
interface TimeFromNowLabelProps {
    time: string | Moment;
    useShortDateFormat?: boolean;
}
const TimeFromNowLabel: FC<TimeFromNowLabelProps> = (props) => {
    return (<span className={styles.when}>
            {props.useShortDateFormat ? <abbr title={DateFormatter.momentAgo(props.time)}>{DateFormatter.dateToShortFormat(props.time)}</abbr> : <abbr title={DateFormatter.dateToLongFormat(props.time)!}>{moment(props.time).fromNow()}</abbr>}
        </span>);
};
export default TimeFromNowLabel;
